module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QwCDQMCwHYhZwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABwSURBVBjTnZCxDQMxDAP5vwV79R6Gc3oZ1+w1gWulMuJP8kEQNoKIAygK+FeSPvrHBtS+994v4LmgzASANSEJY4wnKKlsY84J2yBZtr9GYwci4hJ/SqrWWtkuABURdVtm3UgSmXmQfCuDl9a37/lZD16/OyLlnpYnAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrowupdown.png
 ** module id = 189
 ** module chunks = 0 1
 **/